import { HealthHabitSelectorProps } from "@/shared/types";
import clsx from "clsx";
import { Check } from "lucide-react";
import { Controller } from "react-hook-form";
import { HealthHabitKey } from "../../redux/type";

export function HealthHabitSelector({
  control,
  options,
  layoutClassName,
}: HealthHabitSelectorProps) {
  return (
    <Controller
      control={control}
      name="selectedHabits"
      render={({ field, fieldState }) => {
        const selectedHabits = Array.isArray(field.value) ? field.value : [];

        const toggleHabit = (habitKey: HealthHabitKey) => {
          const nextSelected = selectedHabits.includes(habitKey)
            ? selectedHabits.filter((item) => item !== habitKey)
            : [...selectedHabits, habitKey];

          field.onChange(nextSelected);
        };

        return (
          <div className="space-y-3">
            <div className={layoutClassName ?? "grid grid-cols-2 gap-2 lg:grid-cols-3"}>
              {options.map((option) => {
                const selected = selectedHabits.includes(option.key);
                const Icon = option.icon;

                return (
                  <button
                    type="button"
                    key={option.key}
                    onClick={() => toggleHabit(option.key)}
                    className={clsx(
                      "group relative flex h-12 items-center gap-2 rounded-lg border px-3 py-2 text-left transition-all duration-200",
                      selected
                        ? "border-theme-primary bg-theme-primary/5 shadow-sm"
                        : "border-theme-border-strong bg-theme-surface hover:border-theme-primary/40 hover:bg-theme-primary/5"
                    )}
                  >
                    <span
                      className={clsx(
                        "flex h-7 w-7 shrink-0 items-center justify-center rounded-md border",
                        selected
                          ? "border-theme-primary bg-theme-primary text-white"
                          : "border-theme-border-strong bg-white text-theme-text-soft"
                      )}
                    >
                      <Icon className="h-4 w-4" />
                    </span>

                    <span className="min-w-0 flex-1">
                      <span className="block text-[10px] font-semibold text-theme-text">
                        {option.label}
                      </span>
                      {option.description ? (
                        <span className="mt-0.5 block text-[11px] text-theme-text-soft">
                          {option.description}
                        </span>
                      ) : null}
                    </span>

                    {selected ? (
                      <span className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-theme-primary text-white">
                        <Check className="h-3 w-3" />
                      </span>
                    ) : null}
                  </button>
                );
              })}
            </div>

            {fieldState.error?.message ? (
              <p className="text-xs text-theme-danger-bright">{fieldState.error.message}</p>
            ) : null}
          </div>
        );
      }}
    />
  );
}
